import { render, staticRenderFns } from "./UpdateBronchopneumoniaTableModal.vue?vue&type=template&id=6b927a1a&scoped=true&"
import script from "./UpdateBronchopneumoniaTableModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateBronchopneumoniaTableModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateBronchopneumoniaTableModal.vue?vue&type=style&index=0&id=6b927a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b927a1a",
  null
  
)

export default component.exports